import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import { toast } from 'react-hot-toast';


const firebaseConfig = {
  apiKey: "AIzaSyB9LBzGoM1gVQ-JzSFZjBi-9W_dGVXF16U",
  authDomain: "mar-online-store-5dc99.firebaseapp.com",
  projectId: "mar-online-store-5dc99",
  storageBucket: "mar-online-store-5dc99.appspot.com",
  messagingSenderId: "684865138560",
  appId: "1:684865138560:web:9753a336aa05792afe5b65",
  measurementId: "G-HE7X5XCLJ5"
  
}

const fire = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();

auth.onAuthStateChanged((user) => {
  if (user) {
    // eslint-disable-next-line 
    const uid = user.uid;
    if(user.emailVerified){
      localStorage.setItem('@^&*$£%$!##%admin@^&*$£%$!##%',user.displayName);
    }
  }
})

export default fire;

const sendEmailVerification = () => {
  const user = firebase.auth().currentUser;

  user.sendEmailVerification()
    .then(() => {
      toast.success('Verification Email Sent')
    })
    .catch((error) => {
      // Error occurred while sending verification email
    });
};

export { sendEmailVerification };